import {type ReasoningMessagePartComponent} from '@assistant-ui/react';
import Markdown from '@wandb/weave/common/components/Markdown';
import {MarkdownContainer} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/ChatView/MarkdownContainer';
import React, {memo} from 'react';

import {extractReasoningPreview} from './previews';
import {WBAgentStepDisclosure} from './WBAgentStepDisclosure';

const ReasoningImpl: ReasoningMessagePartComponent = ({text, status}) => {
  return (
    <WBAgentStepDisclosure
      icon="reasoning"
      label="Thinking"
      stepKind="reasoning"
      preview={extractReasoningPreview(text)}
      isRunning={status?.type === 'running'}>
      <div className="text-moon-500">
        <MarkdownContainer>
          <Markdown content={text} shouldEjectFromTailwind={false} />
        </MarkdownContainer>
      </div>
    </WBAgentStepDisclosure>
  );
};

export const WBAgentReasoning = memo(
  ReasoningImpl
) as ReasoningMessagePartComponent;
WBAgentReasoning.displayName = 'WBAgentReasoning';
